export default __webpack_public_path__ + "static/media/qudosScreenShots.e217687e.png";